import React from 'react';

import {Box, Stack, Title} from 'views/components';
import {Translate} from 'views/module';

const ErrorComponent = () => {
  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Stack direction="column" spacing={2}>
        <Title disableDivider sx={{fontWeight: 600}}>
          <Translate expression='generic.Error.OopsSomethingWentWrong'/>
        </Title>
        <Title disableDivider sx={{fontWeight: 600}}>
          <Translate expression='generic.Error.PleaseComeBackLater'/>
        </Title>
      </Stack>
    </Box>
  );
};

export default ErrorComponent;
